module.exports = function() {
  return new Worker(__webpack_public_path__ + "bfa0c7848d81ecc3380c.worker.js");
};